define('presentation/common/routeToModal/presentationObjects/forwardingNumbersPresentationObject',[],function() {
    return function(){
        var self = this;
		self.forwardingNumberId = null;
        self.formattedNumber = null;
    };
});

